import axios from 'axios';

export const httpClient = axios.create({
  baseURL: 'https://api.unityorthoandeyehospital.com/',
});

export default httpClient;
